import { isValid, isNil, TimeUtil } from "@visactor/vutils";

import { getFirstDatumFromTooltipData, getTooltipContentPattern, getTooltipContentValue, getTooltipPatternValue } from "./get-value";

import { TOOLTIP_MAX_LINE_COUNT, TOOLTIP_OTHERS_LINE } from "../constant";

import { getTooltipActualActiveType } from "./common";

const getTimeString = (value, timeFormat, timeFormatMode) => {
    if (!timeFormat && !timeFormatMode) return "object" != typeof value ? null == value ? void 0 : value.toString() : value;
    const timeUtil = TimeUtil.getInstance();
    timeFormat = timeFormat || "%Y%m%d";
    return ("local" === (timeFormatMode = timeFormatMode || "local") ? timeUtil.timeFormat : timeUtil.timeUTCFormat)(timeFormat, value);
};

export const getShowContent = (pattern, data, params) => {
    var _a, _b, _c, _d;
    if (!data || "mouseout" === (null === (_a = null == params ? void 0 : params.event) || void 0 === _a ? void 0 : _a.type)) return null;
    const tooltipActualTitleContent = {
        title: {},
        content: []
    }, patternTitle = getTooltipPatternValue(pattern.title, data, params), {visible: visible, value: value, valueTimeFormat: valueTimeFormat, valueTimeFormatMode: valueTimeFormatMode, valueStyle: valueStyle, hasShape: hasShape, valueFormatter: valueFormatter} = null != patternTitle ? patternTitle : {}, patternTitleVisible = !1 !== getTooltipContentValue(visible, data, params);
    if (patternTitle && patternTitleVisible) {
        const datum = getFirstDatumFromTooltipData(data);
        tooltipActualTitleContent.title = {
            value: getTimeString(getTooltipContentValue(value, datum, params, valueFormatter), valueTimeFormat, valueTimeFormatMode),
            valueStyle: getTooltipContentValue(valueStyle, datum, params),
            hasShape: hasShape
        };
    } else tooltipActualTitleContent.title = {
        hasShape: !1,
        visible: !1
    };
    const patternContent = getTooltipContentPattern(pattern.content, data, params), {maxLineCount: maxLineCount = TOOLTIP_MAX_LINE_COUNT} = pattern, othersLine = pattern.othersLine ? Object.assign(Object.assign({}, TOOLTIP_OTHERS_LINE), pattern.othersLine) : TOOLTIP_OTHERS_LINE, getTooltipContentFromDatumList = datumList => {
        if (null == datumList ? void 0 : datumList.length) for (const datum of datumList) for (const content of null != patternContent ? patternContent : []) {
            const oneLineData = getOneLineData(datum, content, params);
            if (!1 !== oneLineData.visible) {
                if (tooltipActualTitleContent.content.length === maxLineCount - 1) {
                    tooltipActualTitleContent.content.push(Object.assign(Object.assign({}, oneLineData), othersLine));
                    break;
                }
                if (!(tooltipActualTitleContent.content.length < maxLineCount)) break;
                tooltipActualTitleContent.content.push(oneLineData);
            }
        }
    };
    switch (pattern.activeType) {
      case "mark":
        getTooltipContentFromDatumList(null === (_b = data[0]) || void 0 === _b ? void 0 : _b.datum);
        break;

      case "group":
        getTooltipContentFromDatumList(params.groupDatum);
        break;

      case "dimension":
        for (const {data: d} of data) {
            for (const {datum: datumList, series: series} of d) {
                if (!getTooltipActualActiveType(null === (_c = series.tooltipHelper) || void 0 === _c ? void 0 : _c.spec).includes("dimension")) continue;
                const contentPatterns = null !== (_d = null == patternContent ? void 0 : patternContent.filter((c => isNil(c.seriesId) || c.seriesId === series.id))) && void 0 !== _d ? _d : [];
                for (const datum of datumList) {
                    for (const linePattern of contentPatterns) {
                        const oneLineData = getOneLineData(datum, linePattern, params);
                        if (!1 !== oneLineData.visible) {
                            if (tooltipActualTitleContent.content.length === maxLineCount - 1) {
                                tooltipActualTitleContent.content.push(Object.assign(Object.assign({}, oneLineData), othersLine));
                                break;
                            }
                            if (!(tooltipActualTitleContent.content.length < maxLineCount)) break;
                            tooltipActualTitleContent.content.push(oneLineData);
                        }
                    }
                    if (tooltipActualTitleContent.content.length >= maxLineCount) break;
                }
                if (tooltipActualTitleContent.content.length >= maxLineCount) break;
            }
            if (tooltipActualTitleContent.content.length >= maxLineCount) break;
        }
    }
    return tooltipActualTitleContent.title && (tooltipActualTitleContent.content.length > 0 && tooltipActualTitleContent.content[0].shapeType ? (isNil(tooltipActualTitleContent.title.shapeType) && (tooltipActualTitleContent.title.shapeType = tooltipActualTitleContent.content[0].shapeType), 
    isNil(tooltipActualTitleContent.title.shapeColor) && (tooltipActualTitleContent.title.shapeColor = tooltipActualTitleContent.content[0].shapeColor)) : tooltipActualTitleContent.title.hasShape = !1), 
    tooltipActualTitleContent;
};

export const getOneLineData = (datum, config, params) => {
    const key = getTimeString(getTooltipContentValue(config.key, datum, params, config.keyFormatter), config.keyTimeFormat, config.keyTimeFormatMode), value = getTimeString(getTooltipContentValue(config.value, datum, params, config.valueFormatter), config.valueTimeFormat, config.valueTimeFormatMode), visible = !1 !== getTooltipContentValue(config.visible, datum, params) && (isValid(key) || isValid(value)), isKeyAdaptive = getTooltipContentValue(config.isKeyAdaptive, datum, params), spaceRow = getTooltipContentValue(config.spaceRow, datum, params), shapeType = getTooltipContentValue(config.shapeType, datum, params), shapeColor = getTooltipContentValue(config.shapeColor, datum, params), shapeFill = getTooltipContentValue(config.shapeFill, datum, params), shapeStroke = getTooltipContentValue(config.shapeStroke, datum, params), shapeLineWidth = getTooltipContentValue(config.shapeLineWidth, datum, params), shapeHollow = getTooltipContentValue(config.shapeHollow, datum, params), keyStyle = getTooltipContentValue(config.keyStyle, datum, params), valueStyle = getTooltipContentValue(config.valueStyle, datum, params);
    return {
        key: key,
        value: value,
        visible: visible,
        isKeyAdaptive: isKeyAdaptive,
        hasShape: config.hasShape,
        shapeType: shapeType,
        shapeFill: shapeFill,
        shapeStroke: shapeStroke,
        shapeLineWidth: shapeLineWidth,
        shapeHollow: shapeHollow,
        shapeColor: shapeColor,
        keyStyle: keyStyle,
        valueStyle: valueStyle,
        spaceRow: spaceRow,
        datum: datum
    };
};
//# sourceMappingURL=compose.js.map
